class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification');
  //   this.header = document.querySelector('sticky-header');
  //   this.onBodyClick = this.handleBodyClick.bind(this);
  //   this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  //    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
  //    closeButton.addEventListener('click', this.close.bind(this))
  //   );
  //   document.getElementsByClassName("cart-logo")[0].addEventListener("click", this.open.bind(this));   
  }
  
  // open() {
  //  this.notification.classList.add('animate', 'active');
  //   this.notification.addEventListener('transitionend', () => {
  //     this.notification.focus();
  //     trapFocus(this.notification);
  //   }, { once: true });
  //   document.body.addEventListener('click', this.onBodyClick);
  // }

  // close() {
  //   this.notification.classList.remove('active');
  //   document.body.removeEventListener('click', this.onBodyClick);
  //   removeTrapFocus(this.activeElement);
  // }

  renderContents(parsedState) {
    document.getElementById("cart-notification-default").innerHTML="";
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    
    
    //document.getElementsByClassName("cart-logo")[0].addEventListener("click", this.open.bind(this));
	var dropDownIcon = document.querySelector('#cart-icon-bubble');
    if(dropDownIcon.getAttribute("aria-expanded") == "false")
    {
    	dropDownIcon.click();
    }      
    //this.header?.reveal();
    //this.open();
    // console.log(this.querySelector(".total_price").getAttribute("data-total_price"));
   // var totalPrice = parseInt(this.querySelector(".total_price").getAttribute("data-original_total_price"));
    //var text = "";
/*
    if($(".discount-tier" ).hasClass( "standard-customer" )) {
    if(totalPrice >= 24900) {
      if(totalPrice < 50000) {
        text = "40% Off Wholesale Tier STAR $249-$499";
      }
      else if (totalPrice < 100000) {
        text = "50% Off Wholesale Tier DIAMOND $500-$999";
      }
      else {
        text = "55% Off Wholesale Tier CROWN $1000+";
      }
      document.querySelector("cart-notification .discount-tier").classList.remove("hidden");
    }
      else {
      document.querySelector("cart-notification .discount-tier").classList.add("hidden");
    }
    }
      else if($(".discount-tier" ).hasClass( "le-customer" )) {
         if(totalPrice >= 24900) {
      if(totalPrice < 50000) {
        text = "40% Off Wholesale Tier STAR $249-$499";
      }
         else if (totalPrice < 100000) {
        text = "50% Off Wholesale Tier DIAMOND $500-$999";
      }
      else {
        text = "55% Off Wholesale Tier CROWN $1000+";
      }
      document.querySelector("cart-notification .discount-tier").classList.remove("hidden");
    }
        else {
      document.querySelector("cart-notification .discount-tier").classList.add("hidden");
    }
      }
     
    this.querySelector(".discount-tier span").textContent = text; */
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-tier'
      },
      {
        id: 'cart-notification-product',
       // selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
